import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Category, InventoryManager, Item, MenuManager, OrderManager} from 'aigens-ng-core';

@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemComponent implements OnInit, AfterViewInit {

    @Input()
    category: Category;
    @Output()
    removeClick = new EventEmitter();
    @Output()
    addClick = new EventEmitter();
    @Input()
    last: any;
    @Input()
    orderManager: OrderManager;
    img = '';
    isSet = false;
    isModifiable: boolean;
    isRequiredModifier: boolean;
    name: string;
    isSoldout: boolean;
    isParent: boolean;
    @Output()
    private afterLastItemLoadJump = new EventEmitter<string>();

    constructor(private cdr: ChangeDetectorRef, private inventoryManager: InventoryManager, private menuManager: MenuManager) {

    }

    _quantity: number;

    @Input()
    set quantity(quantity: number) {
        this._quantity = quantity;
    }

    _item: Item;

    @Input()
    set item(item: Item) {
        this._item = item;
    }

    ngOnInit(): void {
        this.isParent = !!(this._item.variations && this._item.variations.length > 0);
        this.img = this._item.getImage('default', 150, true);
        this.isSet = Item.isSet(this.category, this._item);
        this.isModifiable = Item.isModifiable(this._item);
        this.isRequiredModifier = this.isModifiable && this._item.mgroups.some(mgroup => mgroup.min > 0);
        this.name = this.getItemName();
        this.isSoldout = this.getSoldout();
    }

    ngAfterViewInit() {
        if (this.last) {// 此时页面已经进入, 不影响首次进入page的性能
            setTimeout(() => {// 为了滚动能获取catTitHeightArr
                this.afterLastItemLoadJump.emit();
                console.log(this.last);
            }, 500);
        }
    }

    getSoldout(): boolean {
        console.log('isSoldout');
        let result: boolean;
        const imSoldout = this.inventoryManager.isSoldout(this._item);
        result = (!this.isParent && imSoldout);
        let now = this.convertNowDateToStoreTimeZone(this.orderManager.store.timezone).getTime();
        return result || !this.menuManager.isAvailableCombo(this.orderManager.store, this.category, this._item, this.orderManager.isTakeout(), now);

    }

    convertNowDateToStoreTimeZone(timeZone): Date {
        timeZone = timeZone ? timeZone : 'GMT+8';
        let timeZoneValue = timeZone.split('GMT')[1];
        // let isPositive = timeZoneValue.startsWith('+');
        let integerTimeZoneValue = parseInt(timeZoneValue) * 60;
        let now = new Date();
        let timeZoneOffset = now.getTimezoneOffset();
        let newTime = now.getTime() + (timeZoneOffset + integerTimeZoneValue) * 60000;

        now.setTime(newTime);
        return now;
    }


    getItemName() {

        let name: string = this._item.name;

        if (this.isParent) {
            name = this._item.title;
        }

        if (!name || name.length === 0) {
            name = this._item.name;
        }

        return name;
    }

    removeClicked() {
        this.removeClick.emit();
    }

    addClicked() {
        this.addClick.emit();
    }


}
